import { Module } from 'vuex'

const promptTopicModule: Module<any, any> = {
    actions: {
        async initPromptTopicIndex(state: any) {
        	if (this.promptTopicIndexLoading) {
        		await this.initPromptTopicPromise
        		return
        	}
            this.promptTopicIndexLoading = true
            this.initPromptTopicPromise = this.dispatch('initIndex', {
                id: 'promptTopic',
                idField: 'id',
                indexedFields: ['name'],
                source: '/api/prompt_topics',
                store: [
                    '@id',
                    '@type',
                    'id',
                    'name',
                    'promptNarratives',
                ],
            })
            await this.initPromptTopicPromise
            this.promptTopicIndexLoading = false
            this.initPromptTopicPromise = null
        },
        
        async getPromptTopics(_, params) {
            const indexExists = await this.dispatch('indexExists', 'promptTopic')
            if (!indexExists || params?.refresh) {
                await this.dispatch('initPromptTopicIndex')
            }

            let records = null
            records = await this.dispatch('getRecords', {
                index: 'promptTopic',
                term: params?.search,
                fields: ['name', 'promptNarratives'],
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
                filters: [],
                sort: null,
            })

            return records
        }
    }
}

export default promptTopicModule
